<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <!-- Header Section -->
    <div class="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
      <div class="px-6 py-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <!-- <button
              class="flex items-center space-x-2 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors"
              @click="$router.go(-1)"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 19l-7-7 7-7"
                />
              </svg>
              <span>Back</span>
            </button> -->
            <div class="flex items-center space-x-2">
              <div
                class="w-8 h-8 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center"
              >
                <svg
                  class="w-5 h-5 text-blue-600 dark:text-blue-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                  />
                </svg>
              </div>
              <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Package View</h1>
            </div>
          </div>
          <div class="flex items-center space-x-3">
            <button
              class="flex items-center space-x-2 px-4 py-2 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
            >
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              <span>Export</span>
            </button>
            <button
              class="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <svg
                class="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                />
              </svg>
              <span>Add</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="p-6">
      <!-- Search and Filters Section -->
      <div
        class="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 mb-6"
      >
        <div class="p-6">
          <!-- Search Bar -->
          <div class="mb-4">
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg
                  class="h-5 w-5 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <input
                v-model="searchQuery"
                type="text"
                class="w-full pl-10 pr-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Search packages: @platform-core/base-service..."
              />
            </div>
          </div>

          <!-- Filter Controls -->
          <div class="flex flex-wrap items-center gap-4">
            <div class="flex items-center space-x-2">
              <label class="text-sm font-medium text-gray-700 dark:text-gray-300"
                >Environment:</label
              >
              <select
                v-model="selectedEnvironment"
                class="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="">All</option>
                <option value="interop">Interop</option>
                <option value="staging">Staging</option>
                <option value="production">Production</option>
              </select>
            </div>

            <button
              class="px-4 py-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
              @click="clearAllFilters"
            >
              Clear All
            </button>
          </div>

          <!-- Active Filters Display -->
          <div
            v-if="hasActiveFilters"
            class="mt-4 flex flex-wrap gap-2"
          >
            <div
              v-for="(value, key) in activeFilters"
              :key="key"
              class="inline-flex items-center px-3 py-1 rounded-full text-sm bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200"
            >
              {{ getFilterLabel(key) }}: {{ value }}
              <button
                class="ml-2 text-blue-600 dark:text-blue-300 hover:text-blue-800 dark:hover:text-blue-100"
                @click="removeFilter(key)"
              >
                ×
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Summary Section -->
      <div
        class="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 mb-6"
      >
        <div class="p-6">
          <div class="flex items-center space-x-2">
            <div
              class="w-8 h-8 bg-green-100 dark:bg-green-900 rounded-lg flex items-center justify-center"
            >
              <svg
                class="w-5 h-5 text-green-600 dark:text-green-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
            </div>
            <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
              Summary: {{ filteredPackages.length }} packages found
            </h2>
          </div>
        </div>
      </div>

      <!-- Packages Table -->
      <div
        class="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700"
      >
        <div class="p-6">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">Packages Table</h3>

          <!-- Loading State -->
          <div
            v-if="loading"
            class="flex items-center justify-center py-8"
          >
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            <span class="ml-3 text-gray-600 dark:text-gray-400">Loading packages...</span>
          </div>

          <DataTable
            v-else
            :data="paginatedPackages"
            :columns="tableColumns"
            :config="tableConfig"
            @row-click="handleRowClick"
          >
            <template #packageName="{ item }">
              <div class="flex items-center space-x-3">
                <div
                  class="w-8 h-8 bg-blue-100 dark:bg-blue-900 rounded-lg flex items-center justify-center"
                >
                  <svg
                    class="w-4 h-4 text-blue-600 dark:text-blue-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                    />
                  </svg>
                </div>
                <div class="min-w-0 flex-1">
                  <button
                    class="font-medium text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 hover:underline text-left"
                    @click.stop="navigateToPackageDetails(item.packageName)"
                  >
                    {{ item.packageName }}
                  </button>
                </div>
              </div>
            </template>

            <template #latestVersion="{ item }">
              <div class="flex items-start">
                <span
                  class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 font-mono"
                >
                  {{ item.latestVersion }}
                </span>
              </div>
            </template>

            <template #versions="{ item }">
              <div class="flex flex-col gap-1.5 py-1">
                <button
                  v-for="version in expandedVersions.has(item.packageName)
                    ? item.versions
                    : item.versions.slice(0, 3)"
                  :key="version"
                  class="inline-flex items-center text-xs font-mono text-gray-700 dark:text-gray-300 bg-gray-50 dark:bg-gray-800 px-2 py-0.5 rounded w-fit hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                  @click.stop="navigateToPackageDetails(item.packageName, version)"
                >
                  {{ version }}
                </button>
                <button
                  v-if="item.versions.length > 3"
                  class="text-xs text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 hover:underline text-left font-medium w-fit"
                  @click.stop="toggleVersions(item.packageName)"
                >
                  {{
                    expandedVersions.has(item.packageName)
                      ? 'Show less'
                      : `+${item.versions.length - 3} more`
                  }}
                </button>
              </div>
            </template>

            <template #workloadCount="{ item }">
              <div class="flex items-start">
                <span class="text-sm text-gray-900 dark:text-white font-medium">
                  {{ item.workloadCount }}
                </span>
              </div>
            </template>

            <template #environments="{ item }">
              <div class="flex flex-wrap gap-1">
                <span
                  v-for="env in item.environments"
                  :key="env"
                  :class="[
                    'inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium',
                    env === 'interop'
                      ? 'bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200'
                      : env === 'staging'
                        ? 'bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200'
                        : 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200'
                  ]"
                >
                  {{ env }}
                </span>
              </div>
            </template>

            <template #row-actions="{ item }">
              <div class="flex items-center space-x-2">
                <button
                  class="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 text-sm font-medium"
                  @click.stop="viewPackageDetails(item)"
                >
                  View Details
                </button>
              </div>
            </template>
          </DataTable>
        </div>
      </div>

      <!-- Pagination -->
      <div class="mt-6 flex items-center justify-between">
        <div class="text-sm text-gray-700 dark:text-gray-300">
          Page {{ currentPage }} of {{ totalPages }}
        </div>
        <div class="flex items-center space-x-2">
          <button
            :disabled="currentPage === 1"
            class="px-3 py-2 text-sm font-medium text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
            @click="currentPage--"
          >
            ← Previous
          </button>
          <button
            v-for="page in displayedPages"
            :key="page"
            :disabled="page === '...'"
            :class="[
              'px-3 py-2 text-sm font-medium rounded-md',
              currentPage === page
                ? 'bg-blue-600 text-white'
                : 'text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700'
            ]"
            @click="currentPage = Number(page)"
          >
            {{ page }}
          </button>
          <button
            :disabled="currentPage === totalPages"
            class="px-3 py-2 text-sm font-medium text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
            @click="currentPage++"
          >
            Next →
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import DataTable from '../../components/shared/DataTable/index.vue'
import { packageVersionService } from '../../services/package-version'
import type { PackageVersion } from '../../types/package-version'
import { logger } from '../../utils/logger'

const router = useRouter()

// Data
const packages = ref<PackageVersion[]>([])
const loading = ref(false)
const expandedVersions = ref<Set<string>>(new Set())

// Search and Filters
const searchQuery = ref('')
const selectedEnvironment = ref('')

// Pagination
const currentPage = ref(1)
const itemsPerPage = 10

// Table Configuration
const tableColumns = [
  { field: 'packageName', label: 'Package Name', sortable: true, searchable: true },
  { field: 'latestVersion', label: 'Latest', sortable: true },
  { field: 'versions', label: 'Versions', sortable: true },
  { field: 'workloadCount', label: 'Workloads', sortable: true },
  { field: 'environments', label: 'Env', sortable: true }
]

const tableConfig = {
  enableSearch: false, // We handle search in the parent
  enableSort: true,
  enablePagination: false, // We handle pagination in the parent
  enableFilter: false
}

// Computed Properties
const activeFilters = computed(() => {
  const filters: Record<string, string> = {}
  if (selectedEnvironment.value) filters.environment = selectedEnvironment.value
  return filters
})

const hasActiveFilters = computed(() => Object.keys(activeFilters.value).length > 0)

const filteredPackages = computed(() => {
  let result = [...packages.value]

  // Apply search
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    result = result.filter(
      (pkg) =>
        pkg.packageName.toLowerCase().includes(query) ||
        pkg.latestVersion.toLowerCase().includes(query) ||
        pkg.environments.some((env: string) => env.toLowerCase().includes(query))
    )
  }

  // Apply filters
  if (selectedEnvironment.value) {
    result = result.filter((pkg) => pkg.environments.includes(selectedEnvironment.value))
  }

  return result
})

const totalPages = computed(() => Math.ceil(filteredPackages.value.length / itemsPerPage))
const paginatedPackages = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage
  const end = start + itemsPerPage
  return filteredPackages.value.slice(start, end)
})

const displayedPages = computed(() => {
  const total = totalPages.value
  const current = currentPage.value
  const range: (number | string)[] = []

  if (total <= 7) {
    for (let i = 1; i <= total; i++) range.push(i)
  } else {
    if (current <= 3) {
      for (let i = 1; i <= 5; i++) range.push(i)
      range.push('...', total)
    } else if (current >= total - 2) {
      range.push(1, '...')
      for (let i = total - 4; i <= total; i++) range.push(i)
    } else {
      range.push(1, '...')
      for (let i = current - 1; i <= current + 1; i++) range.push(i)
      range.push('...', total)
    }
  }

  return range
})

// Methods
const loadPackages = async () => {
  try {
    loading.value = true
    const response = await packageVersionService.getPackages()
    logger.log('API Response:', response)
    // The response should match PackageVersionsResponse type
    if (response && Array.isArray(response.data)) {
      packages.value = response.data
      logger.log('Parsed packages:', packages.value)
    } else {
      logger.error('Invalid response format:', response)
      packages.value = []
    }
  } catch (error) {
    logger.error('Failed to load packages:', error)
  } finally {
    loading.value = false
  }
}

const clearAllFilters = () => {
  searchQuery.value = ''
  selectedEnvironment.value = ''
  currentPage.value = 1
}

const removeFilter = (key: string) => {
  if (key === 'environment') {
    selectedEnvironment.value = ''
  }
  currentPage.value = 1
}

const getFilterLabel = (key: string) => {
  const labels: Record<string, string> = {
    environment: 'Environment',
    status: 'Status',
    version: 'Version'
  }
  return labels[key] || key
}

const handleRowClick = (item: PackageVersion) => {
  // Navigate to package details or handle row click
  logger.log('Row clicked:', item)
}

const viewPackageDetails = (item: PackageVersion) => {
  // Navigate to package details page
  logger.log('View details for:', item)
}

const toggleVersions = (packageName: string) => {
  if (expandedVersions.value.has(packageName)) {
    expandedVersions.value.delete(packageName)
  } else {
    expandedVersions.value.add(packageName)
  }
  // Trigger reactivity
  expandedVersions.value = new Set(expandedVersions.value)
}

const navigateToPackageDetails = (packageName: string, version?: string) => {
  if (version) {
    router.push(`/packages/${encodeURIComponent(packageName)}/${encodeURIComponent(version)}`)
  } else {
    router.push(`/packages/${encodeURIComponent(packageName)}`)
  }
}

// Lifecycle
onMounted(() => {
  loadPackages()
})
</script>

<style scoped>
/* Custom styles for the package view */
</style>
